export const appGroupIdFigmaOauthStatus = "/:app_group_id/figma/oauth/status";
